module.exports = __webpack_public_path__ + "img/request-overview.589030eb.svg";